module.exports = __webpack_public_path__ + "assets/img/snowflake-rb.fefadf33.png";